import React from 'react';

const pageLabels = {
  '/': 'Forside',
  '/om-oss': 'Om oss',
  '/kontakt': 'Kontakt',
  '/kundeservice': 'Kundeservice',
};

function formatPageName(path) {
  if (pageLabels[path]) return pageLabels[path];
  if (path?.startsWith('/category/')) {
    const slug = path.replace('/category/', '');
    const names = {
      blomster: 'Blomsterfrø',
      gronnsaker: 'Grønnsaker',
      krydderurter: 'Krydderurter',
      'okologisk-dyrkning': 'Økologisk dyrkning',
      'bie-og-insektpleie': 'Bie & Insektpleie',
      naturgjodsel: 'Naturgjødsel',
      alle: 'Alle produkter',
    };
    return names[slug] || slug;
  }
  if (path?.startsWith('/product/')) {
    return path.replace('/product/', '').replace(/-/g, ' ').slice(0, 40);
  }
  return path || 'Ukjent';
}

export default function TopPages({ data, loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Topp sider</h3>
        <div className="text-gray-400 text-sm py-8 text-center">Laster...</div>
      </div>
    );
  }

  const maxVisitors = data?.[0]?.visitors || 1;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Topp sider</h3>
        <span className="text-xs text-gray-400">Besøkende</span>
      </div>

      {(!data || data.length === 0) ? (
        <div className="text-gray-400 text-sm py-8 text-center">Ingen data ennå</div>
      ) : (
        <div className="space-y-2">
          {data.map((item, i) => (
            <div key={i} className="relative">
              <div
                className="absolute inset-y-0 left-0 bg-emerald-50 rounded"
                style={{ width: `${(item.visitors / maxVisitors) * 100}%` }}
              />
              <div className="relative flex items-center justify-between px-3 py-2">
                <span className="text-sm text-gray-700 truncate max-w-[70%]" title={item.page}>
                  {formatPageName(item.page)}
                </span>
                <span className="text-sm font-semibold text-gray-900">{item.visitors.toLocaleString('nb-NO')}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
